import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { PoiService, Poi } from '../poi.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Title } from '@angular/platform-browser';
import { MetaService } from 'src/app/meta.service';

@Component({
  selector: 'app-poi-detail',
  templateUrl: './poi-detail.component.html',
  styleUrls: ['./poi-detail.component.sass']
})
export class PoiDetailComponent implements OnInit, OnDestroy {
  poiId: number
  poi?: Poi
  private sub: Subscription = new Subscription();
  imageObjects: Array<object> = []
  numberOfShownImages = 0
  showImages = false
  animateSlideshow = true

  constructor(
    private route: ActivatedRoute, 
    private router: Router, 
    private poiService: PoiService,
    private deviceService: DeviceDetectorService,
    private metaService: MetaService
    ) { }

  ngOnInit() {
    setTimeout(() => {
      this.showImages = true;
    }, 1000);
    this.sub.add(this.route.params.subscribe(params => {
      if (!params['category'] || !params['id']) {
        // console.log("Category and/or id not set", params);
        this.router.navigate(['/']);
      }
      else if (params['category'] !== "badeplatz" && params['category'] !== "restaurant" && params['category'] !== "wanderung") {
          this.router.navigate(['/']);
      }
      else {
        this.poiId = +params['id'].split('-').pop();
        this.sub.add(this.poiService.loadPoi(this.poiId).subscribe(poi => {
          this.poi = poi;
          const poiUrl = this.metaService.slugify(poi.name) + "-" + poi.id;
          if (params['id'] !== poiUrl) {
            this.router.navigate([params['category'], poiUrl]);
          }
          else {
            this.refreshImages();
            this.metaService.setDetailTitle(this.poi);
          }
        }));
      }
    }));
  }

  getCategoryUrl(){
    return this.metaService.getCategoryUrl(this.poi.category);
  }

  getCategoryName() {
    return this.metaService.getCategoryName(this.poi.category);
  }

  getMunicipalityUrl() {
    return this.metaService.slugify(this.poi.municipality);
  }

  getDescription() {
    if(this.poi.detailDescription && this.poi.detailDescription.length > 1) {
      return this.poi.detailDescription;
    }
    return this.poi.description;
  }

  getUrl(title = false) {
    if(title) {
      return this.poi.link.replace("http://", "").replace("https://", "").replace(/\/$/, '');
    }
    return this.poi.link.replace("http://", "https://")
  }

  refreshImages() {
    if (!this.poi.images) {
      return;
    }

    const imageUrls = this.poi.images.split(',').map(image => image.trim());

    this.imageObjects = [];
    imageUrls.forEach((image, index) => {
      const imageObject = { 
        image: image,
        thumbImage: image.replace("/images/", "/images/thumb-300w/"),
        alt: `${ this.poi.category } ${this.poi.name} Bild ${ index + 1 }`,
      }
      this.imageObjects.push( imageObject);
    });

    if (this.imageObjects.length <= 1) {
      this.numberOfShownImages = 1;
      this.animateSlideshow = false;
    }
    else if (this.imageObjects.length == 2) {
      this.numberOfShownImages = 2;
      this.animateSlideshow = false;
    }
    else if (this.deviceService.isMobile()) {
      this.animateSlideshow = true;
      this.numberOfShownImages = 1;
    }
    else {
      this.animateSlideshow = true;
      this.numberOfShownImages = 3;
    }
  }

  showArrows() {
    return (this.deviceService.isMobile() && this.imageObjects.length > 1) || ( this.imageObjects.length > 3 )
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
